// The order of a pipeline's stages after a drag (R-M1): the moved stage takes the middle of its new neighbours; final stages stay last.

export interface Ordered { id: string; order: number }

/** The new `order` of stage `id` put before `target` (or last among open stages, before the finals). */
export function orderBefore(open: Ordered[], finals: Ordered[], id: string, target: string | null): number {
  const rest = open.filter((t) => t.id !== id);
  // A target that is gone (archived meanwhile) or unknown puts the stage last among the open ones.
  const found = target ? rest.findIndex((t) => t.id === target) : -1;
  const at = found < 0 ? rest.length : found;
  const prev = rest[at - 1]?.order, next = rest[at]?.order ?? finals[0]?.order;
  return prev === undefined ? (next ?? 1) - 1 : next === undefined ? prev + 1 : (prev + next) / 2;
}
